import React, {useState} from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

function AppInput(
    {
        label= "",
        placeholder = "",
        value = "",
        setValue = () => {},
        onFocus = () => {},
        onBlur = () => {},
        maxLength = 60,
        type = "text",
        editable = true,
        ...props}) {
    const onChange = editable ? setValue : (e) => {}

    const [active, setActive] = useState(false);

    return <div className={cn(styles.field_input,
        active && editable ? styles.active : styles.inactive,
        !editable && styles.not_editable
    )}>
        <label className={cn(styles.label,
            active && editable ? styles.active : styles.inactive,
            !editable && styles.not_editable)}>
            {label}
        </label>
        <input className={cn(styles.input, !editable && styles.not_editable)}
               value={value}
               placeholder={placeholder}
               maxLength={maxLength}
               type={type}
               contentEditable={"false"}
               onChange={ e => onChange(e.target.value)}
               onFocus={(e) => {
                   setActive(true)
                   onFocus(e)
                   // console.log(e)
               }}
               onBlur={(e) => {
                   setActive(false);
                   onBlur(e)
                   //console.log("ACTIVE", e)
               }}
               {...props}
        />
    </div>;
}


export default AppInput;
